import { notification } from 'components/Notification'
import { VALIDATION_MESSAGES } from 'constants/txt'
import { TPaymentData } from './types'

export const validatePaymentData = (paymentData: TPaymentData) => {
  if (!paymentData.vendor_data.has_linked_bank_accounts) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0240
    })
    return false
  }
  if (!paymentData.vendor_data.has_verified_payable_accounts) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0241
    })
    return false
  }
  if (paymentData.hospital_data) {
    if (!paymentData.hospital_data.has_receivable_account) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0242
      })
      return false
    }
    if (!paymentData.hospital_data.has_default_receivable_account) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0242
      })
      return false
    }
    if (!paymentData.hospital_data.default_receivable_has_ach_credit_standard) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0241
      })
      return false
    }
  }
  if (paymentData.health_system_data) {
    if (!paymentData.health_system_data.has_receivable_account) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0242
      })
      return false
    }
    if (!paymentData.health_system_data.has_default_receivable_account) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0242
      })
      return false
    }
    if (
      !paymentData.health_system_data.default_receivable_has_ach_credit_standard
    ) {
      notification.error({
        message: VALIDATION_MESSAGES.SM0241
      })
      return false
    }
  }
  return true
}
